export default {
    navMenuMaxCount: 100,

    createUrl: '/tp/setting/navEdit',
    fetchUrl: '/v1/kf/nav/setting/getNavMenuList?scene=-1',
    removeUrl: '/v1/kf/nav/setting/removeNavMenu',
    guideFinished: '/tp/IMAccessSet/guideFinished',

    CONVERT_TYPE: {
        TYPE_NO: 0,
        TYPE_YES: 1,
        TYPE_ING: 2
    }
};
